// Replace 'YOUR_API_KEY_HERE' with your actual API key from OpenWeatherMap
const apiKey = 'f04a937aec4db68a055760e05728b684';

// Function to fetch weather data
async function fetchWeather(city, elementId) {
  const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=imperial`;
  const response = await fetch(url);
  const data = await response.json();
  const temperature = data.main.temp;
  document.getElementById(elementId).textContent = `${temperature.toFixed(0)}°`;
}

// Fetch and display weather data for Los Angeles and Panama
fetchWeather('Los Angeles', 'la-temp');
fetchWeather('Panama', 'panama-temp');

//Gallery Images
function debounce(func, wait) {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

let galleryList = document.querySelectorAll('.home-gallery');

galleryList.forEach(function(gallery) {

  gallery.addEventListener('mouseover', function(event) {
    event.preventDefault();
  });

  gallery.addEventListener('mouseover', debounce(function(event) {
    let currentActive = gallery.querySelector('.active');
    if (currentActive) {
      currentActive.classList.remove('active');

      // Get the next element or cycle back to the first child if at the end
      let nextActive = currentActive.nextElementSibling || gallery.firstElementChild;
      nextActive.classList.add('active');
    }
  }, 500)); // 250 milliseconds delay; adjust as needed
});

//Logo fade effect
window.onload = function() {
  let logo = document.querySelector('#home-logo');
  let bottomLogo = document.querySelector('.bottom-logo');

  function fadeOutLogo() {
    gsap.to(logo, {
      duration: .75,
      opacity: 0,
      zIndex: -1,
      ease: "power1.inOut",
      onComplete: () => {
        //console.log("Fade out complete.");
        //document.querySelector('.bottom-logo').classList.add('show');
        gsap.to(bottomLogo, {
          duration: .25,
          opacity: 1,
          ease: "power1.inOut"
        });
      }

    });
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  window.addEventListener('scroll', debounce(function() {
    fadeOutLogo();
  }, 250)); // 250 milliseconds of no-scroll threshold before fade-out triggers
};

//Video controls
let videoBlock = document.querySelectorAll('.home-block.video');

videoBlock.forEach(function(video) {
  let playbackBtn = video.querySelector('.playback-btn');
  let soundBtn = video.querySelector('.sound-btn');
  let videoElement = video.querySelector('video');

  if(playbackBtn){
    playbackBtn.addEventListener('click', function(event) {
      event.preventDefault();
      if (videoElement.paused) {
        videoElement.play();
        playbackBtn.innerHTML = 'Pause';
      } else {
        videoElement.pause();
        playbackBtn.innerHTML = 'Play';
      }
    });
  }

  if(soundBtn){
    soundBtn.addEventListener('click', function(event) {
      event.preventDefault();
      if (videoElement.muted) {
        videoElement.muted = false;
        soundBtn.innerHTML = 'Mute';
      } else {
        videoElement.muted = true;
        soundBtn.innerHTML = 'Sound';
      }
    });
  }
});

// GSAP code to add/remove .color class to/from header based on scroll position
  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.create({
    trigger: ".video",
    start: "top top+=48", // when the top of the video div hits 48px from the top of the viewport
    end: "bottom top+=48", // when the bottom of the video div hits 48px from the top of the viewport
    onEnter: () => document.querySelector("header").classList.add("mobile-white"),
    onLeaveBack: () => document.querySelector("header").classList.remove("mobile-white")
    // onEnter: () => document.querySelector("header").classList.remove("transparent"),
    // onLeaveBack: () => document.querySelector("header").classList.add("transparent")
  });